import {Headline} from 'quickstart/components/content/Headline'
import {UniversalLink} from 'quickstart/components/content/UniversalLink'
import * as R from 'rambdax'
import type {ComponentProps} from 'react'
import {type MetaObject, deepMerge, logger} from 'tizra'
import {
  type SlotConfig,
  type SlotName,
  defaultSlots,
  useMetadata,
} from '../MetaTile/common'
import {metaHeadlineSlots} from './slots'

const log = logger('MetaHeadline')

type MetaHeadlineProps = ComponentProps<typeof Headline> & {
  metaObj?: MetaObject
  slots?: {[k in SlotName]?: SlotConfig}
}

export const MetaHeadline = ({
  metaObj,
  slots: _slots,
  ...props
}: MetaHeadlineProps) => {
  const slots = R.pick(
    Object.keys(metaHeadlineSlots),
    deepMerge(defaultSlots)(_slots),
  ) as Exclude<typeof _slots, undefined>

  const {href, cover, title} = useMetadata({
    metaObj,
    slots,
    thumbProps: {cover: true, ratio: 3 / 2, position: 'center center'},
  })

  return (
    <Headline
      as={href ? UniversalLink : undefined}
      {...(href && {href})}
      {...props}
    >
      <Headline.Cover>{cover}</Headline.Cover>
      <Headline.Body>
        {title && <Headline.Heading>{title}</Headline.Heading>}
      </Headline.Body>
    </Headline>
  )
}
